import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_EE.json';
import exercises from './FITNESS_EXERCISES_EE.json';
import recipes from './FITNESS_RECIPES_EE.json';

export const FITNESS_DATA_EE: ServiceData = {
  articles,
  exercises,
  recipes,
};
